export default function (Component) {
Component.options.__title = "Alert and `v-model`"
}